import MdEditor, {
  MarkdownEditorRef as MdEditorRef,
} from "features/markdown/blocks/MarkdownEditor";
import React from "react";
import type { CardContentValidationResult } from "utils/card-content-validation";

type CardEditorProps = {
  initialValue?: string;
  showMd?: boolean;
  titleValue?: string;
  onTitleChange?: (value: string) => void;
  onContentChange?: (value: string) => void;
  sphereSelector?: React.ReactNode;
  variantSelector?: React.ReactNode;
  showSphereSelector?: boolean;
  editorRef?: React.RefObject<MdEditorRef>;
  titleInputRef?: React.RefObject<HTMLInputElement>;
  sphereInputRef?: React.RefObject<HTMLDivElement>;
  validation?: CardContentValidationResult;
  objectType?: "problem" | "solution" | "attribute";
};

const CardEditor: React.FC<CardEditorProps> = ({
  initialValue = "",
  showMd = false,
  titleValue = "",
  onTitleChange,
  onContentChange,
  sphereSelector,
  variantSelector,
  showSphereSelector = false,
  editorRef,
  titleInputRef,
  sphereInputRef,
  validation,
  objectType,
}) => {
  const titleMessage =
    validation?.title.errorText || validation?.title.warningText;
  const contentMessage =
    validation?.description.errorText || validation?.description.warningText;

  const placeholderText =
    objectType === "problem"
      ? "Введите текст проблемы..."
      : objectType === "solution"
        ? "Введите текст решения..."
        : objectType === "attribute"
          ? "Введите текст характеристики..."
          : "Введите текст...";

  const titlePlaceholderText =
    objectType === "problem"
      ? "Введите заголовок проблемы..."
      : objectType === "solution"
        ? "Введите заголовок решения..."
        : objectType === "attribute"
          ? "Введите заголовок характеристики..."
          : "Введите заголовок...";

  return (
    <div className="flex-form">
      {showSphereSelector && sphereSelector && (
        <div
          className="input"
          ref={sphereInputRef}
        >
          {sphereSelector}
        </div>
      )}
      {variantSelector && <div className="input">{variantSelector}</div>}

      <div className="input">
        <input
          ref={titleInputRef}
          style={{
            marginTop: "5px",
            width: "99%",
            fontSize: "20px",
            marginBottom: "8px",
          }}
          value={titleValue}
          onChange={(e) => onTitleChange?.(e.target.value)}
          placeholder={titlePlaceholderText}
          type="text"
        />
        {titleMessage && (
          <div
            className={
              validation?.title.isOverLimit
                ? "field-validation error"
                : "field-validation warning"
            }
          >
            {titleMessage}
          </div>
        )}
      </div>

      <div className="editor-block">
        <MdEditor
          ref={editorRef}
          initialValue={initialValue}
          onChange={onContentChange}
          placeholder={placeholderText}
          showModeSwitch={showMd}
          height="100%"
        />
        {contentMessage && (
          <div
            className={
              validation?.description.isOverLimit
                ? "field-validation error"
                : "field-validation warning"
            }
          >
            {contentMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default CardEditor;
